// Global render tracking (only active when performance monitor is mounted)
let globalRenderCount = 0;
const renderTimestamps: number[] = [];

// Export function to track renders (called by Profiler in App.tsx)
export const trackRender = () => {
  globalRenderCount++;
  const now = performance.now();
  renderTimestamps.push(now);

  // Keep only last 60 timestamps (1 minute at ~1 render/second)
  if (renderTimestamps.length > 60) {
    renderTimestamps.shift();
  }
};

// Calculate renders per second from timestamps
export const calculateRendersPerSecond = (): number => {
  if (renderTimestamps.length < 2) return 0;

  // Calculate RPS over last 5 seconds
  const now = performance.now();
  const fiveSecondsAgo = now - 5000;
  const recentRenders = renderTimestamps.filter(t => t > fiveSecondsAgo);

  if (recentRenders.length < 2) return 0;

  const timeSpan = now - recentRenders[0];
  const rps = (recentRenders.length / timeSpan) * 1000;

  return Math.round(rps * 10) / 10; // Round to 1 decimal place
};

export const getGlobalRenderCount = (): number => globalRenderCount;
